import styled from '@emotion/styled'
import { calcRem, colors, fonts, themedValue } from '../../../__styling'

const getBorderColor = (theme: any, colorMode: 'light' | 'dark') =>
    colorMode === 'dark'
        ? colors.white20
        : themedValue(theme, {
              sevennews: 'transparent',
              fallback: colors.black20,
          })

const getTextColor = (theme: any, colorMode: 'light' | 'dark') =>
    colorMode === 'dark'
        ? colors.white
        : themedValue(theme, {
              sevennews: colors.white,
              fallback: colors.black,
          })

const getHoverTextColor = (theme: any) =>
    themedValue(theme, {
        sevennews: colors.white,
        fallback: colors.white,
    })

export const StyledCommonwealthGamesWidgetCtaArrow = styled('span', {
    shouldForwardProp: (prop) => prop !== 'colorMode',
})<{ colorMode?: 'light' | 'dark' }>`
    position: absolute;
    right: ${calcRem(26)};
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme, colorMode = 'light' }) =>
        colorMode === 'dark'
            ? colors.white
            : themedValue(theme, {
                  sevennews: colors.white,
                  fallback: colors.black,
              })};
    transition: 0.35s all ease-in-out;
`

export const StyledCommonwealthGamesWidgetCtaLoading = styled('div')({
    '& .js-skeleton': {
        display: 'block',
        width: '100%',
    },
    '& .js-skeleton [class*="StyledSkeleton"]': {
        margin: 0,
        borderRadius: calcRem(8),
    },
})

const commonwealthGamesWidgetCtaBaseStyles = ({
    theme,
    colorMode = 'light',
}: {
    theme: any
    colorMode?: 'light' | 'dark'
}) => `
    appearance: none;
    border-radius: ${calcRem(8)};
    border: 1px solid ${getBorderColor(theme, colorMode)};
    color: ${getTextColor(theme, colorMode)};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${themedValue(theme, {
        sevennews: fonts.sevennews.sansSerif,
        thenightly: fonts.thenightly.sansSerif,
        perthnow: fonts.perthnow.sansSerif,
        fallback: fonts.thewest.sansSerif,
    })};
    font-size: ${calcRem(19)};
    line-height: ${calcRem(22)};
    font-weight: 700;
    min-height: ${calcRem(40)};
    padding: ${calcRem(9, 38, 9, 14)};
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: 0.35s all ease-in-out;
    width: 100%;
    background-color: transparent;
    background-image: ${themedValue(theme, {
        sevennews: colors.commonwealthGamesGradient,
        fallback: 'none',
    })};
    background-size: ${themedValue(theme, {
        sevennews: '160% 160%',
        fallback: 'auto',
    })};
    background-position: ${themedValue(theme, {
        sevennews: '0% 50%',
        fallback: '0 0',
    })};

    &:hover,
    &:focus {
        color: ${getHoverTextColor(theme)};
        background-position: ${themedValue(theme, {
            sevennews: '100% 50%',
            fallback: '0 0',
        })};
    }

    &:hover ${StyledCommonwealthGamesWidgetCtaArrow},
    &:focus ${StyledCommonwealthGamesWidgetCtaArrow} {
        color: ${getHoverTextColor(theme)};
        transform: translateY(-50%) translateX(3px);
    }
`

export const StyledCommonwealthGamesWidgetCtaButton = styled('button', {
    shouldForwardProp: (prop) => prop !== 'colorMode',
})<{ colorMode?: 'light' | 'dark' }>`
    ${({ theme, colorMode = 'light' }) =>
        commonwealthGamesWidgetCtaBaseStyles({ theme, colorMode })}
`

export const StyledCommonwealthGamesWidgetCtaLink = styled('a', {
    shouldForwardProp: (prop) => prop !== 'colorMode',
})<{ colorMode?: 'light' | 'dark' }>`
    ${({ theme, colorMode = 'light' }) =>
        commonwealthGamesWidgetCtaBaseStyles({ theme, colorMode })}
`
